/*
 * @Description: 项目配置文件
 * @Author: Mars
 * @Date: 2023-11-20 09:51:50
 */

const config = {
  /** GA key */
  gaTrackingId: import.meta.env.VITE_GA4_MEASUREMENT_ID,
  /** tinymce资源地址 */
  tinymceUrl: `${import.meta.env.VITE_STATIC_RES_PREFIX}/js/tinymce`,
  /** 官网地址 */
  officialWebsiteAddress: [
    {
      countryCode: 'DE',
      url: 'https://alphaess.de/',
    },
    {
      countryCode: 'NL',
      url: 'https://www.alphaess.nl/',
    },
    {
      countryCode: 'GB',
      url: 'https://www.alpha-ess.co.uk/',
    },
    {
      countryCode: 'IT',
      url: 'https://www.alphaess.it/',
    },
    {
      countryCode: 'BE',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'AT',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'FR',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'ES',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'CZ',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'PL',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'LU',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'CH',
      url: 'https://eu.alphaess.com/',
    },
    /** 欧洲其他国家 */
    {
      countryCode: '110000000000004other',
      url: 'https://eu.alphaess.com/',
    },
    {
      countryCode: 'AU',
      url: 'https://www.alphaess.au/',
    },
    {
      countryCode: 'NZ',
      url: 'https://www.alphaess.com/',
    },
    {
      countryCode: 'PH',
      url: 'https://www.alphaess.com/',
    },
    {
      countryCode: 'PK',
      url: 'https://www.alphaess.com/',
    },
    {
      countryCode: 'TH',
      url: 'https://www.alphaess.com/',
    },
    {
      countryCode: 'VN',
      url: 'https://www.alphaess.com/',
    },
    /** 亚太其他国家 */
    {
      countryCode: '110000000000002other',
      url: 'https://www.alphaess.com/',
    },
    {
      countryCode: 'US',
      url: 'https://www.alphaess.com/',
    },
    /** 北美其他国家 */
    {
      countryCode: '110000000000006other',
      url: 'https://www.alphaess.com/',
    },
    /** 非洲 */
    {
      countryCode: '110000000000005',
      url: 'https://www.alphaess.com/',
    },
    /** 拉丁美洲 */
    {
      countryCode: '110000000000040',
      url: 'https://www.alphaess.com/',
    },
  ],
  /** 户用云平台地址（6.1） */
  alphaCloudAddress: `${import.meta.env.VITE_ALPHA_CLOUD_ADDRESS}`,
  /** Antelope Portal 地址（新平台） */
  antelopePortalAddress: import.meta.env.VITE_ANTELOPE_PORTAL_ADDRESS,
  /** 安装商平台地址 */
  installerPlatformAddress: import.meta.env.VITE_INSTALLER_PLATFORM_ADDRESS,
  /** 隐私政策 */
  privacyPolicy: import.meta.env.VITE_PRIVACY_POLICY,
  /** 领英 */
  inAddress: 'https://cn.linkedin.com/company/alphaess',
  /** X */
  XAddress: 'https://twitter.com/AlphaESS',
  /** facebook */
  facebookAddress: 'https://www.facebook.com/AlphaEnergyStorageSystem',
  /** YouTube */
  youTubeAddress: 'https://www.youtube.com/channel/UCWzbFsyGDBjhXS8QY1TLHCw/videos',
  /** ins */
  insAddress: 'https://www.instagram.com/alpha_ess/',
  /** 客诉隐私政策 */
  ticketsCenterPrivacyPolicy: 'https://cloud.alphaess.com/complaintAgreeDescription',
  /** 客诉中心路径前缀 */
  TICKETS_PATH: '/service_and_support',
  countryList: [
    {
      continentName: 'europe',
      list: [
        {
          name: 'germany',
          countryCode: 'DE',
          language: 'de-DE',
          subsidiaryCode: 'DE',
        },
        {
          name: 'united_kingdom',
          countryCode: 'GB',
          language: 'en-US',
          subsidiaryCode: 'GB',
        },
        {
          name: 'belgium',
          countryCode: 'BE',
          language: 'en-US',
          subsidiaryCode: 'DE',
        },
        {
          name: 'czech_republic',
          countryCode: 'CZ',
          language: 'en-US',
          subsidiaryCode: 'DE',
        },
        {
          name: 'italy',
          countryCode: 'IT',
          language: 'en-US',
          subsidiaryCode: 'IT',
        },
        {
          name: 'austria',
          countryCode: 'AT',
          language: 'de-DE',
          subsidiaryCode: 'DE',
        },
        {
          name: 'ireland',
          countryCode: 'IE',
          language: 'en-US',
          subsidiaryCode: 'DE',
        },
        {
          name: 'denmark',
          countryCode: 'DK',
          language: 'en-US',
          subsidiaryCode: 'DE',
        },
        {
          name: 'netherlands',
          countryCode: 'NL',
          language: 'nl-NL',
          // language: 'en-US',
          subsidiaryCode: 'DE',
        },
      ],
    },
    {
      continentName: 'asia_pacific',
      list: [
        {
          name: 'china',
          countryCode: 'CN',
          language: 'zh-CN',
          subsidiaryCode: 'CN',
        },
        {
          name: 'australia',
          countryCode: 'AU',
          language: 'en-US',
          subsidiaryCode: 'AU',
        },
        {
          name: 'new_zealand',
          countryCode: 'NZ',
          language: 'en-US',
          subsidiaryCode: 'NZ',
        },
        {
          name: 'french_polynesia',
          countryCode: 'PF',
          language: 'en-US',
          subsidiaryCode: 'CN',
        },
        {
          name: 'philippines',
          countryCode: 'PH',
          language: 'en-US',
          subsidiaryCode: 'CN',
        },
        {
          name: 'pakistan',
          countryCode: 'PK',
          language: 'en-US',
          subsidiaryCode: 'CN',
        },
        {
          name: 'thailand',
          countryCode: 'TH',
          language: 'en-US',
          subsidiaryCode: 'CN',
        },
        {
          name: 'japan',
          countryCode: 'JP',
          language: 'en-US',
          subsidiaryCode: 'JP',
        },
        {
          name: 'singapore',
          countryCode: 'SG',
          language: 'en-US',
          subsidiaryCode: 'SG',
        },
      ],
    },
    {
      continentName: 'america_and_africa',
      list: [
        {
          name: 'usa',
          countryCode: 'US',
          language: 'en-US',
          subsidiaryCode: 'US',
        },
        {
          name: 'south_africa',
          countryCode: 'ZA',
          language: 'en-US',
          subsidiaryCode: 'ZA',
        },
      ],
    },
    {
      continentName: 'other',
      list: [
        {
          name: 'other_sites',
          countryCode: 'ZZ',
          language: 'en-US',
          subsidiaryCode: 'SG',
        },
      ],
    },
  ],
  /** 默认的国家 */
  defaultCountryInfo: {
    continentName: 'Global',
    name: 'Global',
    countryCode: 'global',
    language: 'en-US',
  },
  /** 子公司的国家,默认是新加坡SG */
  subsidiaryCodeList: ['DE', 'GB', 'IT', 'CN', 'SG', 'AU', 'NZ', 'JP', 'KR', 'US', 'ZA'],
  defaultSubsidiaryCode: 'SG',
  /** 默认语言 */
  defaultLanguage: 'en-US',
  /** 首页展示视频的语言 */
  videoLanguage: ['en-US', 'de-DE'],
  /** 支持的语言列表 */
  languageList: [
    { name: '中文', code: 'zh-CN' },
    { name: 'English', code: 'en-US' },
    { name: 'Deutsch', code: 'de-DE' },
    { name: 'Italiano', code: 'it-IT' },
    { name: 'Nederlands', code: 'nl-NL' },
    { name: 'España', code: 'sp-SP' },
    { name: 'Français', code: 'fr-FR' },
    { name: 'Ελληνικά', code: 'el-GR' },
    { name: 'Polski', code: 'pl-PL' },
    { name: 'Čeština', code: 'cs-CZ' },
  ],
};

/** 是否为开发环境 */
export const isDev = import.meta.env.MODE === 'production' || import.meta.env.MODE === 'huidu' ? false : true;

export default config;
